import { LoanSidebarSessionLoan } from "./types";

export const isActiveLoanMatch = (
  sessionLoan: LoanSidebarSessionLoan,
  rowLoan: LoanSidebarSessionLoan,
): boolean => {
  if (!sessionLoan.loanKey || !rowLoan.loanKey) {
    return false;
  }

  return sessionLoan.losType === rowLoan.losType && sessionLoan.loanKey === rowLoan.loanKey;
};
